/** Route order for horizontal slide direction (left ↔ right). */
export const NAV_ROUTES = ['/', '/history', '/sessions/new'] as const;

export function navRouteIndex(pathname: string): number {
  if (pathname === '/') return 0;
  if (pathname.startsWith('/sessions/new')) return 2;
  if (pathname.startsWith('/history')) return 1;
  return 0;
}

export function slideEnterClass(fromIndex: number, toIndex: number, spring = false): string {
  if (fromIndex === toIndex) return 'oche-enter-fade';
  if (spring) {
    return toIndex > fromIndex ? 'oche-enter-spring-forward' : 'oche-enter-spring-back';
  }
  return toIndex > fromIndex ? 'oche-enter-forward' : 'oche-enter-back';
}

export function useNavActiveId(pathname: string): string {
  if (pathname === '/') return '/';
  if (pathname.startsWith('/sessions/new')) return '/sessions/new';
  if (pathname.startsWith('/history')) return '/history';
  return '/';
}
